module.exports = __webpack_public_path__ + "img/admin-tier-model.85d13874.png";